import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PostTypesTableComponent } from './post-types-table/post-types-table.component';
import { EventSelectorComponent } from './event-selector/event-selector.component';
import { PostTypeEditorComponent } from './post-type-editor/post-type-editor.component';

const routes: Routes = [
  { path: '', component: PostTypesTableComponent, children: [] },
  { path: 'select-event', component: EventSelectorComponent },
  { path: 'create', component: PostTypeEditorComponent },
  { path: 'edit/:typeId', component: PostTypeEditorComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RoutingModule {}
